// extracted by mini-css-extract-plugin
module.exports = {"root":"_3e8cbd185879cc9d0d7f353e88f0f971-less","spaced":"d231ff3fccc551ecd3423349f18d36a1-less","error":"d6fa790a8c2ee843fc243c8d6814de11-less"};